export default __webpack_public_path__ + "static/media/chat-green.2ed5ab89.png";